"use strict";

require("core-js/modules/es.array.join");

require("core-js/modules/es.array.map");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.promise");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDeviceId = getDeviceId;
exports.getSessionId = getSessionId;
exports.JAKTE_SESSION_ID_KEY = exports.JAKTE_DEVICE_ID_KEY = void 0;

require("regenerator-runtime/runtime");

var _v = _interopRequireDefault(require("uuid/v4"));

var _fingerprintjs = _interopRequireDefault(require("fingerprintjs2"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var JAKTE_DEVICE_ID_KEY = 'jakte:device-id';
exports.JAKTE_DEVICE_ID_KEY = JAKTE_DEVICE_ID_KEY;
var JAKTE_SESSION_ID_KEY = 'jakte:user-id';
exports.JAKTE_SESSION_ID_KEY = JAKTE_SESSION_ID_KEY;

function generateDeviceId() {
  return new Promise(function (resolve) {
    setTimeout(function () {
      _fingerprintjs.default.get(function (result) {
        var values = result.map(function (r) {
          return r.value;
        });
        resolve(_fingerprintjs.default.x64hash128(values.join(''), 31));
      });
    }, 500);
  });
}

function generateSessionId() {
  return (0, _v.default)();
}

function getDeviceId() {
  return _getDeviceId.apply(this, arguments);
}

function _getDeviceId() {
  _getDeviceId = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee() {
    var existingDeviceId, deviceId;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            existingDeviceId = sessionStorage.getItem(JAKTE_DEVICE_ID_KEY);

            if (!(existingDeviceId != null)) {
              _context.next = 3;
              break;
            }

            return _context.abrupt("return", existingDeviceId);

          case 3:
            _context.next = 5;
            return generateDeviceId();

          case 5:
            deviceId = _context.sent;
            sessionStorage.setItem(JAKTE_DEVICE_ID_KEY, deviceId);
            return _context.abrupt("return", deviceId);

          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _getDeviceId.apply(this, arguments);
}

function getSessionId() {
  var existingSessionId = sessionStorage.getItem(JAKTE_SESSION_ID_KEY);

  if (existingSessionId != null) {
    return existingSessionId;
  }

  var sessionId = generateSessionId();
  sessionStorage.setItem(JAKTE_SESSION_ID_KEY, sessionId);
  return sessionId;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@drawbotics/jakte-core/lib/ids.js
// module id = 535
// module chunks = 0